import styled, { css } from 'styled-components'
import RichText from '@berlitz/globals/lib/components/RichText'

export const StyledRichText = styled(RichText)`
  &,
  strong,
  div,
  p {
    font-size: ${({ theme }) => theme.fontSize.xxxs};
  }
`

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  font-size: ${({ theme }) => theme.fontSize.xxs};
  display: ${({ buttonInline }) => (buttonInline ? 'flex' : 'block')};
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${({ theme }) => theme.fontSize.xs};

    ${({ theme, fixed }) =>
      !fixed &&
      css`
        margin: 0 auto;
        padding: 0 ${theme.space.xs};
        width: ${theme.flexboxgrid.width};
      `};
  }
`
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ buttonInline, theme }) =>
    buttonInline ? '0' : theme.space.xs};
  margin-left: ${({ buttonInline, theme }) =>
    buttonInline ? theme.space.xs : '0'};
  white-space: nowrap;
  display: ${({ buttonInline, theme }) =>
    buttonInline ? theme.space.xs : '0'};

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    ${({ buttonInline }) =>
      buttonInline &&
      css`
        margin-left: ${({ theme }) => theme.space.md};
        margin-top: 0;
      `};
  }

  a {
    margin-right: ${({ theme }) => theme.space.xs};
  }
`
export const StickyAlertWrapper = styled.div`
  bottom: 0;
  position: fixed;
  z-index: ${({ index }) => 110 - index};
  max-width: ${({ theme }) => theme.breakpoints.sm};
  transition: ${({ theme }) => theme.animation.transitionMedium};
  box-shadow: ${({ theme }) => theme.elevation.md};
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    bottom: ${({ theme }) => theme.space.md};
    left: ${({ theme }) => theme.space.md};
  }

  ${({ isActive }) =>
    isActive
      ? css`
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          opacity: 0;
          transform: translateY(100%);
          pointer-events: none;
        `}
`
